import { LoadablePaint } from '@confluence/loadable';

export const SmartCreatePromptLoader = LoadablePaint({
	name: 'SmartCreatePromptLoader',
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SmartCreatePrompt" */ '../src/SmartCreatePrompt'))
			.SmartCreatePrompt,
});
